import React, { useEffect, useState } from "react";
import banner from "assets/img/profile/banner.png";
import UserService from "services/user.service";
import { IoMdClose } from "react-icons/io";
import Avatar from "react-avatar";
import moment from "moment";


const EventsModal = ({ profileData, isOpen, onClose }) => {
  if (!isOpen) return null;
  console.log("Profile data 👉", profileData);
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70 p-2 sm:p-4">
      <div className="max-h-[90vh] w-[95%] sm:w-[700px] overflow-auto rounded-xl bg-navy-800 px-3 pb-3 sm:px-6 sm:pb-6 shadow-lg">
        <div className="flex justify-end py-2 sm:py-3">
          <IoMdClose className="cursor-pointer text-xl sm:text-2xl" onClick={onClose} />
        </div>
        <div
          className="relative mt-1 flex h-[150px] sm:h-[200px] w-full justify-center rounded-xl bg-cover"
          style={{
            backgroundImage: `url(${profileData?.images[0]?.includes("http")
              ? profileData?.images[0]
              : process.env.REACT_APP_BASE_URL + profileData?.images[0]
              })`,
          }}
        >
          <div className="absolute -bottom-16 sm:-bottom-20 left-4 sm:left-10 flex h-[90px] w-[90px] sm:h-[120px] sm:w-[120px] items-center justify-center rounded-full border-[3px] sm:border-[4px] !border-navy-700 bg-pink-400">
            {profileData?.accountDetails?.profilepic ? (
              <img
                src={
                  profileData?.accountDetails?.profilepic?.includes("http")
                    ? profileData?.accountDetails?.profilepic
                    : process.env.REACT_APP_BASE_URL +
                    profileData?.accountDetails?.profilepic
                }
                alt="Profile"
                className="h-full w-full rounded-full object-cover"
              />
            ) : (
              <Avatar
                name={profileData.title}
                className="h-full w-full rounded-full"
              />
            )}
          </div>
          {/* Name and position */}
          <div className="absolute -bottom-[32px] sm:-bottom-[40px] left-28 sm:left-44 flex flex-col">
            <h4 className="text-sm sm:text-xl font-bold capitalize text-white">
              {profileData?.accountDetails?.firstname
                ? profileData?.accountDetails?.firstname +
                (profileData?.accountDetails?.lastname &&
                  " " + profileData?.accountDetails?.lastname)
                : "--"}{" "}
              ({profileData?.accountDetails?.account_type})
            </h4>
          </div>
        </div>

        <div className="mt-20 sm:mt-24">
          <h4 className="text-lg sm:text-xl font-bold capitalize text-white">
            {profileData.title ? profileData.title : "--"}
          </h4>
          <p className="mb-3 sm:mb-4 break-all text-sm sm:text-base font-normal text-gray-600">
            {profileData.description ? profileData.description : "--"}
          </p>
          <div className="grid grid-cols-6 gap-1 sm:gap-1.5">
            <p className="col-span-1 text-xs sm:text-base font-normal text-gray-600">
              Likes:
            </p>
            <p className="col-span-2 break-all text-xs sm:text-base font-normal text-white">
              {profileData.likecount}
            </p>
            <p className="col-span-1 text-xs sm:text-base font-normal text-gray-600">
              Comments:
            </p>
            <p className="col-span-2 break-all text-xs sm:text-base font-normal text-white">
              {profileData.commentcount}
            </p>
            <p className="col-span-1 text-xs sm:text-base font-normal text-gray-600">
              Shares:
            </p>
            <p className="col-span-2 break-all text-xs sm:text-base font-normal text-white">
              {profileData.sharecount}
            </p>
            <p className="col-span-1 text-xs sm:text-base font-normal text-gray-600">
              Type:
            </p>
            <p className="col-span-2 break-all text-xs sm:text-base font-normal text-white">
              {profileData.type}
            </p>
            <p className="col-span-1 text-xs sm:text-base font-normal text-gray-600">
              Address:
            </p>
            <p className="col-span-2 break-all text-xs sm:text-base font-normal text-white">
              {profileData.address ? profileData.address : "--"}
            </p>
            <p className="col-span-1 text-xs sm:text-base font-normal text-gray-600">
              City:
            </p>
            <p className="col-span-2 break-all text-xs sm:text-base font-normal text-white">
              {profileData.city ? profileData.city : "--"}
            </p>
            <p className="col-span-1 text-xs sm:text-base font-normal text-gray-600">
              State:
            </p>
            <p className="col-span-2 break-all text-xs sm:text-base font-normal text-white">
              {profileData.state ? profileData.state : "--"}
            </p>
            <p className="col-span-1 text-xs sm:text-base font-normal text-gray-600">
              Country:
            </p>
            <p className="col-span-2 break-all text-xs sm:text-base font-normal text-white">
              {profileData.country ? profileData.country : "--"}
            </p>
            <p className="col-span-1 text-xs sm:text-base font-normal text-gray-600">
              Zip Code:
            </p>
            <p className="col-span-2 break-all text-xs sm:text-base font-normal text-white">
              {profileData.zipcode ? profileData.zipcode : "--"}
            </p>

            <p className="col-span-1 text-xs sm:text-base font-normal text-gray-600">
              Activated:
            </p>
            <p className="col-span-2 break-all text-xs sm:text-base font-normal text-white">
              {profileData.isActive ? "Yes" : "No"}
            </p>

            <p className="col-span-1 text-xs sm:text-base font-normal text-gray-600">
              Start Date:
            </p>
            <p className="col-span-2 break-all text-xs sm:text-base font-normal text-white">
              {profileData.startdate
                ? moment.utc(profileData.startdate).format("DD/MM/YYYY hh:mm A")
                : "--"}
            </p>

            <p className="col-span-1 text-xs sm:text-base font-normal text-gray-600">
              End Date:
            </p>
            <p className="col-span-2 break-all text-xs sm:text-base font-normal text-white">
              {profileData.enddate
                ? moment.utc(profileData.enddate).format("DD/MM/YYYY hh:mm A")
                : "--"}
            </p>

            <p className="col-span-1 text-xs sm:text-base font-normal text-gray-600">
              Date of Birth:
            </p>
            <p className="col-span-2 break-all text-xs sm:text-base font-normal text-white">
              {profileData?.accountDetails?.dateofbirth
                ? moment
                  .utc(profileData?.accountDetails?.dateofbirth)
                  .format("DD/MM/YYYY hh:mm A")
                : "--"}
            </p>
            <p className="col-span-1 text-xs sm:text-base font-normal text-gray-600">
              Latitude:
            </p>
            <p className="col-span-2 break-all text-xs sm:text-base font-normal text-white">
              {profileData.location
                ? profileData?.location?.coordinates?.[0]
                : "--"}
            </p>
            <p className="col-span-1 text-xs sm:text-base font-normal text-gray-600">
              Longitude:
            </p>
            <p className="col-span-2 break-all text-xs sm:text-base font-normal text-white">
              {profileData.location
                ? profileData?.location?.coordinates?.[1]
                : "--"}
            </p>

            {/* Ticket Details */}
            <p className="col-span-6 mt-4 text-sm sm:text-lg font-bold text-white">
              Ticket Details
            </p>

            {/* <div className="grid grid-cols-6 gap-y-1 sm:gap-y-1 gap-x-0.5 sm:gap-x-28"> */}
            {profileData?.ticketStats?.ticketOptions.map((ticket, index) => (
              <React.Fragment key={index}>
                {/* Title */}
                <p className="col-span-1 text-xs sm:text-base font-medium text-white">
                  {ticket.title}
                </p>

                {/* Total */}
                <p className="col-span-1 text-xs sm:text-base ">
                  <span className="text-gray-600">Total: </span>{" "}
                  <span className="text-white"> {ticket.totalTickets}</span>
                </p>


                {/* Sold */}
                <p className="col-span-1 text-xs sm:text-base text-white">
                  <span className="text-gray-600">Sold:</span>{" "}
                  <span className="text-white"> {ticket.soldTickets}</span>
                </p>

                {/* Scanned */}
                <p className="col-span-3 text-xs sm:text-base text-white">
                  <span className="text-gray-600">Scanned:</span>{""}
                  <span className="text-white"> {ticket.scannedTickets}</span>
                </p>
              </React.Fragment>
            ))}
            {/* </div> */}



          </div>
        </div>
      </div>
    </div>
  );
};

export default EventsModal;
